import { Component, ViewChild } from '@angular/core';
import {  DataSourceGrid  } from '../../../utils/data-source-grid.component';
import {  MatPaginator,MatDialog, MatSort } from '@angular/material';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DatosGeneralesSAE } from '../../../datos-generales-SAE';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'consulta-de-pagos',
    styleUrls: [], 
    templateUrl: 'consulta-de-pagos.component.html',
    providers: [generalService]
})

export class ConsultaPagosComponent {
  public datosGeneralesSAE: any;
  dataAprobacion: DataSourceGrid | null;
  displayedColumns = ['columna', 'columnaI', 'columnaII', 'columnaIII', 'columnaIV', 'columnaV'];
  public idVenta: number;
  public historialAprobacion:Array<any>;
  public detallesAprobacion:Array<any>;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public organizationId = this.userData.ORGANIZATION_ID;
  public parametroUrl:any;
  public nombreCompraVenta:string;

constructor( public dialog: MatDialog,  
             private _generalService: generalService,
             public dataService: DataService,
             public _activated : ActivatedRoute) {
  this.historialAprobacion = new Array();
  this.datosGeneralesSAE = DatosGeneralesSAE;
  this.datosGeneralesSAE.showSpinnerLoading = true;
  this.idVenta = this.dataService.id;

  this._activated.params.forEach((params: Params)=>{
    this.parametroUrl = params['parametro'];
    console.log(this.parametroUrl);
  });
}

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


	ngOnInit() {    
    this.consultaPagos(this.idVenta);
    this.validarNombre();
  }
    
  consultaPagos(idVenta){
    let consultaPagos = "HistorialPagos/consultaPagos/" + idVenta;
    this._generalService.metodoCall(consultaPagos).subscribe(
      result => { 
        this.historialAprobacion = JSON.parse(result);
        if (this.historialAprobacion.length > 0) {
          this.dataAprobacion = new DataSourceGrid(this.historialAprobacion, this.paginator, this.sort);
        }
        this.consultaPagosDetalles(idVenta);
        if(this.historialAprobacion.length <= 0)
          { $(".mat-row").remove(".mat-row"); 
            this.dataService.acceso = 0;
            this.cerrarModal(); }
        },
      error => {  console.log(<any>error);  }
    );
  }

  consultaPagosDetalles(idPayment){
    let consultaDetalles = "HistorialPagos/consultaPagosDetalles/" + idPayment;
    this._generalService.metodoCall(consultaDetalles).subscribe(
      result => { 
        this.detallesAprobacion = JSON.parse(result);
        this.datosGeneralesSAE.showSpinnerLoading = false;  },
      error => {  console.log(<any>error);  }
    );
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }


  crearTicketPago(idPayment: any){
    console.log(this.organizationId, idPayment);
    this.datosGeneralesSAE.showSpinnerLoading = true;
    var bandera = false;
    // Se consulta la información y configuración del ticket en base al pago y sucursal
    this._generalService.requestGet("pago/crearTicketPago?idOrganization=" + this.organizationId + "&idPayment=" + idPayment + "&bandera=" + bandera).subscribe(
        (result) => {

            // El primer paso para imprimir el ticket es transformar la base64 a un arreglo de bytes con el cual se obtendrá un 
            // objeto blob
            const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];
                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
            const blob = b64toBlob(result, "application/pdf");

            // Se crea una url valida con el objeto blob
            const blobUrl = URL.createObjectURL(blob);

            // Se elimina el iframe del ticket si ya había sido creado uno
            if (document.getElementById("iframeTicketII") != null){
                $("#iframeTicketII").remove();
            }

            // Se crea un iframe para el ticket y se le pone como src el url creado apartir del blob
            var iframe: any = document.createElement('iframe');
            iframe.id = "iframeTicketII";
            iframe.style.display = 'none';
            iframe.src = blobUrl;
            document.body.appendChild(iframe);

            // Se pone en un timeout en lo que se espera a que se agrege al body del document y se pueda imprimir
            setTimeout(()=>{    
                // Se imprime el ticket
                iframe.focus();
                iframe.contentWindow.print();

                this.datosGeneralesSAE.showSpinnerLoading = false;
           }, 100);

        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
        }
    );

  }

  validarNombre(){
    this.parametroUrl == ':parametro' ? this.nombreCompraVenta = "compra" : this.nombreCompraVenta = ""
  }
}





// WEBPACK FOOTER //
// ./src/app/venta/consultar/consulta-de-pagos/consulta-de-pagos.component.ts